import React from 'react';
import PropTypes from 'prop-types';
import {
  FDContentContainer,
  FDStack,
  FDStat,
} from '@facet-wealth/design';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { ResourcesItemList } from '../../DebtMinPaymentsSection/Content';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride(['currentMonthlyExpenseTotal', 'nextTwelveMonthsExpenseTotal', 'expensesReducibilityPercentage'], {
    _component: () => FDStat,
  }, {
    ordinal: 200,
  });

const MonthlyExpensesLayout = () => {
  const { resource } = useMetaLayoutContext();

  return (
    <FDContentContainer maxWidth="sm">
      <FDStack direction="row" alignItems="stretch" spacing={2}>
        <FDStack spacing={2} flexGrow={1}>
          <MetaControlField attr="currentMonthlyExpenseTotal" />
        </FDStack>
        <FDStack spacing={2} flexGrow={1}>
          <MetaControlField attr="nextTwelveMonthsExpenseTotal" />
        </FDStack>
      </FDStack>
      <ResourcesItemList collection={resource.attr('expenses')} pluralListItemName="Expenses" />
      {resource.attr('expensesReducibilityPercentage')
        && (
          <FDStack spacing={2} flexGrow={1}>
            <MetaControlField attr="expensesReducibilityPercentage" />
          </FDStack>
        )
      }
    </FDContentContainer>
  );
};

const MonthlyExpensesSection = ({
  resource,
}) => {
  if (!resource) {
    return null;
  }

  return (
    <MetaFormInline
      padding="none"
      noIndividualSubmitButtons
      resource={resource}
      layout={MonthlyExpensesLayout}
      metaOverrideSet={metaOverrideSet}
    />
  );
};

MonthlyExpensesSection.defaultProps = {};

MonthlyExpensesSection.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default MonthlyExpensesSection;
